webpackJsonp([188035677499097],{

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fees = function fees() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Fees'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Fees are due at the time of service and are payable by cash or check. First appointment fee reflects extended office visit, while follow-up appointments are less.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Please contact me at 206-335-8017 or by email at\xA0',
	      _react2.default.createElement(
	        'a',
	        { href: 'mailto:sharkeyacupuncture@gmail.com' },
	        'sharkeyacupuncture@gmail.com'
	      ),
	      ' ',
	      'for my current fee schedule.'
	    )
	  );
	};
	
	exports.default = fees;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-fees-js-d05db3998974bc5bee1b.js